import { Buffer } from 'buffer'

declare global {
  interface Window {
    Buffer?: typeof Buffer
  }
}

if (typeof globalThis !== 'undefined' && !(globalThis as any).Buffer) {
  ;(globalThis as any).Buffer = Buffer
}

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer
}
